// export const V1_API_URL_PREFIX = window.location.protocol + process.env.REACT_APP_BASE_URL + (window.location.protocol.startsWith("https") ? ":443" : ":8080") + "/api/v1";
let url = window.location.href
let arr = url.split("/");
export const V1_API_URL_PREFIX = arr[0] + "//" + process.env.REACT_APP_BASE_URL + (arr[0].startsWith("https") ? ":8443" : ":8080") +"/api/v1";
export const ACCESS_TOKEN = 'accessToken';
export const BOUND_USER_ID = 'boundUserId';
//export const BASE_URL = window.location.protocol + process.env.REACT_APP_BASE_URL + (process.env.NODE_ENV === "production" ? "" : ":3000");
export const BASE_URL = arr[0] + "//" + process.env.REACT_APP_BASE_URL + (process.env.NODE_ENV === "production" ? "" : ":3000");
export const TNC_URL_PATH = '/pdf/TermsAndConditions_rev_2_1_March-2022.pdf';
console.log("window.location.protocol", arr[0]);